@if (type=='login') {
  <div mat-dialog-title i18n>Anmeldung</div>
  <div mat-dialog-content>
    <form [formGroup]="loginForm" #formDirective="ngForm">
      <div class="content">
        <app-input-text [innerWidth]="2" i18n-label label="Login Name" formName="username" [formGroup]="loginForm" autofocus></app-input-text>
        <app-newline></app-newline>
        <app-password [innerWidth]="2" i18n-label label="Passwort" formName="password" [formGroup]="loginForm"></app-password>
        <app-newline></app-newline>
        <app-input-text i18n-label label="Two Factor Code" formName="tfacode" [formGroup]="loginForm"></app-input-text>
      </div>
      @if (txtError!=null) {
        <mat-error>{{txtError}}</mat-error>
      }
    </form>
  </div>
  <div mat-dialog-actions>
    <button mat-raised-button (click)="loginClick()" i18n>Anmelden</button>
    <button mat-button (click)="toggleTypeClick()" i18n>Ich habe noch keine Anmeldedaten</button>
  </div>
}

@if (type=='register') {
  <div mat-dialog-title i18n>Registrierung</div>
  <form [formGroup]="registerForm" #formDirective="ngForm">
    <div class="content">
      <app-input-text [innerWidth]="2" i18n-label label="Login Name" formName="username" [formGroup]="registerForm" autofocus></app-input-text>
      <app-newline></app-newline>
      <app-input-text [innerWidth]="2" i18n-label label="Voller Name" formName="fullname" [formGroup]="registerForm"></app-input-text>
      <app-newline></app-newline>
      <app-password [innerWidth]="2" i18n-label label="Passwort" formName="password" [formGroup]="registerForm"></app-password>
    </div>
    @if (!registerForm.pristine && registerForm.invalid) {
      <mat-error>
        <ul>
          @if (registerForm.get('username').value?.length < 4) {
            <li>Loginname ist zu kurz</li>
          }
          @if (registerForm.get('password').value?.length < 4) {
            <li>Passwort ist zu kurz</li>
          }
        </ul>
      </mat-error>
    }
  </form>
  <div mat-dialog-actions>
    <button mat-raised-button (click)="registerClick()" i18n>Registrieren</button>
    <button mat-button (click)="toggleTypeClick()" i18n>Ich bin schon bekannt</button>
  </div>
}

@if (type=='qrcode') {
  <div mat-dialog-title i18n>Zwei Faktor Autorisierung</div>
  <form [formGroup]="tfaForm" #formDirective="ngForm">
    @if (tfaurl!=null) {
      <img [src]="tfaurl" alt="2FA">
    }
    @if (tfaurl==null) {
      <mat-icon>wait</mat-icon>
    }
    <div lbl i18n>Bitte diesen Code mit einer TFA App einscannen, den Code, den die App generiert eingeben und mit dem Button bestätigen.</div>
    <app-input-text i18n-label label="Erzeugter Code" formName="tfacode" [formGroup]="tfaForm"></app-input-text>
    @if (txtError!=null) {
      <mat-error>{{txtError}}</mat-error>
    }
  </form>
  <div mat-dialog-actions>
    <button mat-raised-button (click)="tfaClick()" i18n>Code bestätigen</button>
  </div>
}
